import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { useResponsive } from "@/hooks/useResponsive";
import { LazoUser } from "@/models/LazoUser";
import { Box } from "@mui/material";
import { useMemo } from "react";
import { DrawerSettingsSupportSection } from "./DrawerSettingsSupportSection";
import { DrawerUserSection } from "./DrawerUserSection";
import LazoPortalAndOneToggle from "./LazoPortalAndOneToggle";

interface LazoDrawerFooterProps {
  lazoUser: LazoUser;
  open: boolean;
}

export function LazoDrawerFooter(props: LazoDrawerFooterProps) {
  const { isDesktop } = useResponsive();
  const authorized = useMemo(
    () =>
      (AuthService.hasPermissionFor("Lazo:Portal:Access") && AuthService.hasPermissionFor("Lazo:One:Access")) ||
      AuthService.hasPermissionFor("App:Administration"),
    []
  );

  return (
    <Box
      sx={{
        margin: "0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-end",
        height: "100%",
        opacity: "100%",
        gap: 1,
      }}
    >
      <DrawerSettingsSupportSection open={props.open} />
      {/*<DrawerAddonsSections />*/}
      {authorized && props.open && <LazoPortalAndOneToggle />}
      {!isDesktop && <DrawerUserSection lazoUser={props.lazoUser} />}
    </Box>
  );
}
